import { render, staticRenderFns } from "./pluginManage.vue?vue&type=template&id=33ee2f0a&scoped=true"
import script from "./pluginManage.vue?vue&type=script&lang=js"
export * from "./pluginManage.vue?vue&type=script&lang=js"
import style0 from "./pluginManage.vue?vue&type=style&index=0&id=33ee2f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee2f0a",
  null
  
)

export default component.exports